import axios from 'axios'

export const getCustomtext = (id: string) => {
  return axios.get(
    axios.defaults.baseURL + 'customtext/bbltexts/Landingsside/' + id
  )
}
